import { TranslateService } from '@ngx-translate/core';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { CmsService } from '@spartacus/core';
import { combineLatest, Subject } from 'rxjs';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { SdTitleComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'wc-navigation-paragraph',
  templateUrl: './navigation-paragraph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    RouterLink
  ]
})
export class NavigationParagraphComponent implements OnInit {
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private readonly cmsService: CmsService,
    private readonly translateService: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {}

  currentNavigation = [];
  title = '';

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component'].filter(Boolean).join(' ');
  }

  ngOnInit(): void {
    this.title = this.translateService.instant('cgvTitle');
    this.cmsService
      .getCurrentPage()
      .pipe(
        filter((page) => !!page),
        switchMap((page) => {
          const components$ = page.slots['DynamicBody'].components.map((cmp) =>
            this.cmsService.getComponentData(cmp.uid)
          );
          return combineLatest(components$);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((components) => {
        this.currentNavigation = components;
        this.cdRef.markForCheck();
      });
  }
}
